import { render } from "./SystemLevelNotifications.vue?vue&type=template&id=1a76d02c"
import script from "./SystemLevelNotifications.vue?vue&type=script&lang=js"
export * from "./SystemLevelNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/SystemLevelNotifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a76d02c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a76d02c', __exports__)) {
    api.reload('1a76d02c', __exports__)
  }
  
  module.hot.accept("./SystemLevelNotifications.vue?vue&type=template&id=1a76d02c", () => {
    api.rerender('1a76d02c', render)
  })

}


export default __exports__